
import { Component, Prop, Vue } from 'vue-property-decorator'
import InputAnswerText from '@/components/molecules/InputAnswerText.vue'
import KatexMixedText from '@/components/molecules/KatexMixedText.vue'
import ButtonInput from '@/components/organisms/study/ButtonInput.vue'
import { StudyModel } from '@/models/StudyModel'
import { DrawingModel } from '@/models/DrawingModel'

/**
 * 英語入力イベント発生時の処理型
 */
export type InputEnglishFunction = (
  question: StudyModel.Question,
  index: number,
  afterFunction: StudyModel.AfterInputEnglishFunction
) => void

/**
 * 設問情報の解答欄表示(英語)
 */
@Component({
  components: {
    InputAnswerText,
    KatexMixedText,
    ButtonInput,
  },
})
export default class InputEnglish extends Vue {
  /** 設問情報 */
  @Prop()
  private question!: StudyModel.Question

  /** 入力時の処理 */
  @Prop()
  private inputEnglish!: InputEnglishFunction

  /** アクティブな入力欄のインデックス */
  private activeIndex: number = 0

  /** 入力値の更新タイムスタンプ(DOMを更新させるために使う) */
  private updatedAt: number = 0

  /**
   * 表示用要素の取得
   *
   * @returns 入力式の表示用要素(配列)
   */
  private get items(): StudyModel.FrontValueEnglish[] {
    return this.question.contents.map((content) => {
      return content.frontValues as StudyModel.FrontValueEnglish
    })
  }

  /**
   * 入力イベント
   *
   * @param index 入力欄のインデックス
   */
  private input(index: number): void {
    this.activeIndex = index
    this.inputEnglish(this.question, index, this.afterFunction)
  }

  /**
   * 入力後の処理
   *
   * @param value 入力値
   * @param inputType 入力モード
   * @param strokes ストローク情報
   */
  private afterFunction(value: string, inputType: string, strokes: DrawingModel.Stroke[]): void {
    // 値の更新
    this.question.inputValues[this.activeIndex] = value
    const questionContent = this.question.contents[this.activeIndex] as StudyModel.ContentEnglish
    questionContent.inputType = inputType
    questionContent.strokes.splice(0)
    questionContent.strokes.push(...strokes)
    // DOM更新のためキー値を書き換え
    this.updatedAt = new Date().valueOf()
  }
}
